<template>
  <div>
    <Menu />

    <div v-if="loading">
      <center><div class="spinner"></div></center>
      <h2 class="text-center">Loading development</h2>
    </div>

    <div v-if="!loading && !developmentFound">
      <div class="container py-5 text-center">
        <h1>Development not found</h1>
        <p>The requested development could not be found.</p>
        <a href="/developments" class="btn btn-primary">Back to developments</a>
      </div>
    </div>

    <div v-if="!loading && developmentFound">
      <section>
        <div id="banner" class="mt-5 mb-3">
          <div class="container">
            <div class="row justify-content-center g-0">
              <div class="col-12">
                <div class="banner-section porfolio-banner porfolio-banner6">
                  <div class="row g-0">
                    <div class="col-lg-4 col-md-5 align-self-center order-1 pe-2">
                      <h4>
                        {{ development.title }}
                        <span>{{ development.ref_id }}</span>
                      </h4>

                      <div class="underLineBorder"></div>

                      <div class="priceTag pb-3" v-if="hasPriceRange">
                        {{ formatCurrency(development.low_price) }}
                        -
                        {{ formatCurrency(development.high_price) }}
                      </div>

                      <div class="priceTag pb-3" v-else>
                        POA
                      </div>
                    </div>

                    <div class="col-lg-8 col-md-6 col-sm-7 order-md-2 order-sm-4 order-2">
                      <button
                        type="button"
                        class="btn"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasBottom"
                        aria-controls="offcanvasBottom"
                        style="padding: 0; border: none; background: transparent; width: 100%; height: auto;"
                      >
                        <img
                          :src="getImageUrl(development.cover_image)"
                          class="mw-100 banner-image"
                          style="border-top-left-radius: 30px;"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasBottom"
          aria-controls="offcanvasBottom"
          class="btn w-100 gallery-button"
        >
          <i class="bi bi-images"></i> View Gallery
        </button>


        <!-- Gallery Offcanvas -->
        <div
          class="offcanvas offcanvas-bottom"
          id="offcanvasBottom"
          tabindex="-1"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel" style="color: black;">
              GALLERY VIEW
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <div class="offcanvas-body">
            <div class="photo-album" v-if="galleryImages.length">
              <div
                class="photo-row"
                v-for="(image, index) in galleryImages"
                :key="index"
              >
                <div class="photo-item">
                  <a :href="image" data-lightbox="development-gallery">
                    <img :src="image" class="img-fluid" />
                  </a>
                </div>
              </div>
            </div>

            <div v-else class="container text-center py-5">
              <h3>No gallery images available</h3>
            </div>
          </div>
        </div>

        <!-- Main Gallery Preview -->
        <div class="container-fluid mt-4" v-if="galleryImages.length">
          <div class="row g-2 px-lg-5">
            <div class="col-lg-6" v-if="galleryImages[0]">
              <button
                type="button"
                class="btn gallery-preview-btn"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasBottom"
                aria-controls="offcanvasBottom"
              >
                <img :src="galleryImages[0]" class="w-100 main-gallery-image" />
              </button>
            </div>

            <div class="col-lg-6">
              <div class="row g-2">
                <div
                  class="col-6"
                  v-for="(image, index) in galleryPreviewImages"
                  :key="index"
                >
                  <button
                    type="button"
                    class="btn gallery-preview-btn"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasBottom"
                    aria-controls="offcanvasBottom"
                  >
                    <img :src="image" class="w-100 small-gallery-image" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- About -->
        <div class="pt-lg-5">
          <div class="wrapper">
            <div class="container">
              <div class="row">
                <div class="col-12 mb-5">
                  <div class="switch-bg-lgrey p-sm-5 p-4 pb-5 about-block">
                    <h5 class="switch-ddblue mb-4">About this development</h5>
                    <p
                      v-for="(paragraph, index) in formattedDescription"
                      :key="index"
                    >
                      {{ paragraph }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="row justify-content-center pb-5 mb-5">
                <div class="col-md-3 col-sm-6">
                  <div class="prop-details">
                    {{ formatCurrency(development.low_price) }}
                    <span>STARTING FROM</span>
                  </div>
                </div>

                <div class="col-md-3 col-sm-6" v-if="properties.length">
                  <div class="prop-details">
                    {{ properties.length }}
                    <span>PROPERTY TYPES</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Amenities / Activities -->
          <div class="wrapper">
            <div class="container">
              <div class="row mt-5">
                <div class="col-12 mt-4">
                  <ul class="nav nav-tabs temp6-tabs justify-content-center" id="developmentTabs" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="amenities-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#amenities-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="amenities-tab-pane"
                        aria-selected="true"
                      >
                        Amenities
                      </button>
                    </li>

                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="activities-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#activities-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="activities-tab-pane"
                        aria-selected="false"
                      >
                        Activities
                      </button>
                    </li>
                  </ul>

                  <div class="tab-content" id="developmentTabsContent">
                    <div
                      class="tab-pane fade show active p-lg-5 p-3"
                      id="amenities-tab-pane"
                      role="tabpanel"
                      aria-labelledby="amenities-tab"
                      tabindex="0"
                    >
                      <h5 class="switch-ddblue mb-4">Amenities</h5>
                      <p>{{ development.amenities }}</p>
                    </div>

                    <div
                      class="tab-pane fade p-lg-5 p-3"
                      id="activities-tab-pane"
                      role="tabpanel"
                      aria-labelledby="activities-tab"
                      tabindex="0"
                    >
                      <h5 class="switch-ddblue mb-4">Activities</h5>
                      <p>{{ development.activities }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Child Properties -->
          <div class="container pb-5 mb-5" v-if="properties.length">
            <div class="row pt-5">
              <div class="col-12 text-center mb-4">
                <h1>Available Properties</h1>
                <p>Explore available homes within this development.</p>
              </div>

              <div
                class="col-md-4 mt-4"
                v-for="(property, index) in properties"
                :key="index"
              >
                <div class="banner-section lifestyle-block switch-bg-lgrey p-3 h-100 bord-radius">
                  <div class="portfolio-thumbnail" v-if="property.image">
                    <img :src="getImageUrl(property.image)" class="w-100 force-height" />

                    <div class="thumbnail-priceTag">
                      From {{ formatCurrency(property.from_price) }}
                    </div>
                  </div>

                  <div class="portfolio-thumbnail no-image" v-else>
                    <div class="thumbnail-priceTag">
                      From {{ formatCurrency(property.from_price) }}
                    </div>
                  </div>

                  <h4 class="text-start mt-3">
                    Property {{ index + 1 }}
                  </h4>

                  <p>{{ property.description }}</p>

                  <div class="row text-center mt-3">
                    <div class="col-6" v-if="property.erf_size">
                      <div class="mini-detail">
                        {{ property.erf_size }}
                        <span>ERF SIZE</span>
                      </div>
                    </div>

                    <div class="col-6" v-if="property.floor_size">
                      <div class="mini-detail">
                        {{ property.floor_size }}
                        <span>FLOOR SIZE</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Contact -->
          <div class="container-fluid bg-light">
            <div class="row">
              <div class="col-12 text-center mt-3">
                <h1>CONTACT DETAILS</h1>
              </div>
            </div>

            <div class="row justify-content-center pt-5 pb-5">
              <div class="col-md-5 text-center">
                <h3 class="switch-blue mb-3">
                  <strong>{{ development.contact_name }}</strong>
                </h3>

                <p style="line-height: 28px;">
                  <a
                    v-if="development.contact_phone"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="'tel:' + development.contact_phone"
                  >
                    <i class="bi bi-telephone-fill"></i>
                    {{ development.contact_phone }}
                  </a>
                  <br v-if="development.contact_phone" />

                  <a
                    v-if="development.contact_email"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="'mailto:' + development.contact_email"
                  >
                    <i class="bi bi-envelope-fill"></i>
                    {{ development.contact_email }}
                  </a>
                  <br v-if="development.contact_email" />

                  <a
                    v-if="whatsappLink"
                    style="text-decoration: none;"
                    class="switch-blue"
                    :href="whatsappLink"
                    target="_blank"
                  >
                    <i class="bi bi-whatsapp"></i>
                    Whatsapp
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  name: 'Development',

  components: {
    Menu,
    Footer
  },

  data() {
    return {
      loading: true,
      developmentFound: false,
      development: {},
      meta: {},
      allDevelopments: [],
      imageBaseUrl: 'https://luxury-dev.chaseveritt.co.za/'
    }
  },

  created() {
    this.fetchDevelopment()
  },

  computed: {
    developmentId() {
      return this.$route.params.developmentId
    },

    hasPriceRange() {
      if (this.development.low_price && this.development.high_price) {
        return true
      }

      return false
    },

    properties() {
      if (this.development.properties && this.development.properties.length) {
        return this.development.properties
      }

      return []
    },

    galleryImages() {
      const images = []

      if (this.development.cover_image) {
        images.push(this.getImageUrl(this.development.cover_image))
      }

      if (this.development.image_gallery && this.development.image_gallery.length) {
        this.development.image_gallery.forEach((image) => {
          if (image.url) {
            const imageUrl = this.getImageUrl(image.url)

            if (images.indexOf(imageUrl) === -1) {
              images.push(imageUrl)
            }
          }
        })
      }

      return images
    },

    galleryPreviewImages() {
      return this.galleryImages.slice(1, 5)
    },

    formattedDescription() {
      if (!this.development.description) {
        return []
      }

      const rawDescription = String(this.development.description)
      const sentences = rawDescription.split('. ')
      const paragraphs = []

      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ')

        if (paragraph !== '') {
          if (!paragraph.endsWith('.')) {
            paragraphs.push(paragraph + '.')
          } else {
            paragraphs.push(paragraph)
          }
        }
      }

      return paragraphs
    },

    currentUrl() {
      return encodeURIComponent(window.location.href)
    },

    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },

    pinterestShareLink() {
      const title = encodeURIComponent(this.development.title || 'Luxury Development')
      const image = encodeURIComponent(this.getImageUrl(this.development.cover_image))

      return `http://pinterest.com/pin/create/bookmarklet/?media=${image}&url=${this.currentUrl}&is_video=false&description=${title}`
    },

    whatsappLink() {
      if (!this.development.contact_phone) {
        return ''
      }

      const currentUrl = window.location.href
      const cleanedNumber = this.development.contact_phone.replace(/\D/g, '')
      const countryCode = '27'
      const formattedNumber = cleanedNumber.startsWith(countryCode)
        ? cleanedNumber
        : countryCode + cleanedNumber

      return `https://wa.me/${formattedNumber}?text=Hello! I am interested in the development I found on your Portfolio website: ${currentUrl}`
    }
  },

  methods: {
    async fetchDevelopment() {
      this.loading = true
      this.developmentFound = false

      try {
        const response = await axios.get(
          'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_all_developments.php',
          { headers: { Accept: 'application/json' } }
        )

        if (
          response.data &&
          response.data.success === true &&
          Array.isArray(response.data.developments)
        ) {
          this.allDevelopments = response.data.developments
          this.findCurrentDevelopment()
        }
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },

    findCurrentDevelopment() {
      let matched = null

      this.allDevelopments.forEach((item) => {
        const row = this.getDevelopmentRow(item)
        const meta = item.meta || {}

        if (!matched && row.ref_id === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }

        if (!matched && meta.ref_id === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }

        if (!matched && this.slugify(row.title) === this.developmentId) {
          matched = {
            development: row,
            meta: meta
          }
        }
      })

      if (matched) {
        this.development = matched.development
        this.meta = matched.meta
        this.developmentFound = true
        this.setPageMeta()
      }
    },

    getDevelopmentRow(item) {
      if (
        item &&
        item.development &&
        item.development.data &&
        item.development.data.development &&
        item.development.data.development[0]
      ) {
        return item.development.data.development[0]
      }

      return {}
    },

    getImageUrl(path) {
      if (!path) {
        return this.imageBaseUrl + 'developments-images/placeholder.jpg'
      }

      if (path.indexOf('http') === 0) {
        return path
      }

      return this.imageBaseUrl.replace(/\/$/, '') + '/' + path.replace(/^\//, '')
    },

    formatCurrency(value) {
      if (!value) {
        return ''
      }

      const numberValue = Number(String(value).replace(/[^0-9.-]+/g, ''))

      if (Number.isNaN(numberValue)) {
        return value
      }

      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        maximumFractionDigits: 0
      }).format(numberValue)
    },

    slugify(value) {
      if (!value) {
        return 'development'
      }

      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
    },

    setPageMeta() {
      document.title = this.development.seo_meta || this.development.title || 'Luxury Development'

      const description = this.development.description || ''
      const image = this.getImageUrl(this.development.cover_image)

      this.setMetaTag('description', description)
      this.setMetaTag('keywords', this.development.seo_keywords || '')

      this.setOgTag('og:title', this.development.title || 'Luxury Development')
      this.setOgTag('og:description', description)
      this.setOgTag('og:image', image)
      this.setOgTag('og:url', window.location.href)
    },

    setMetaTag(name, content) {
      let tag = document.querySelector(`meta[name="${name}"]`)

      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('name', name)
        document.head.appendChild(tag)
      }

      tag.setAttribute('content', content)
    },

    setOgTag(property, content) {
      let tag = document.querySelector(`meta[property="${property}"]`)

      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('property', property)
        document.head.appendChild(tag)
      }

      tag.setAttribute('content', content)
    }
  }
}
</script>

<style scoped>
.spinner {
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.2s linear infinite;
  margin-top: 80px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.banner-image {
  width: 100%;
  height: 520px;
  object-fit: cover;
}

.gallery-button {
  padding: 0;
  border: none;
  background: transparent;
  height: auto;
  text-decoration: underline;
  color: #255699;
}

.gallery-preview-btn {
  padding: 0;
  border: none;
  background: transparent;
  width: 100%;
}

.main-gallery-image {
  height: 470px;
  object-fit: cover;
}

.small-gallery-image {
  height: 231px;
  object-fit: cover;
}

.force-height {
  height: 300px;
  object-fit: cover;
}

.no-image {
  min-height: 300px;
  background: #efefef;
  position: relative;
}

.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}

.offcanvas.offcanvas-bottom {
  height: 100vh;
  max-height: 100vh;
  top: 0;
}

.photo-album {
  margin: 0;
  padding: 0;
}

.photo-row {
  display: flex;
  margin: 0;
  padding: 0;
}

.photo-item {
  width: 100%;
  padding: 8px 14px;
}

.photo-item img {
  width: 100%;
  height: 620px;
  object-fit: cover;
  border-radius: 0;
}

.mini-detail {
  font-size: 20px;
  font-weight: bold;
}

.mini-detail span {
  display: block;
  font-size: 11px;
  font-weight: normal;
  text-transform: uppercase;
}

@media (max-width: 991.98px) {
  .banner-image,
  .main-gallery-image,
  .small-gallery-image,
  .photo-item img {
    height: 320px;
  }

  .fixed-tags {
    display: none;
  }
}
</style>